// Universal max-input headroom to avoid exact-balance execution edge cases.
export const MAX_INPUT_BUFFER_BPS = 10n // 0.10%
export const MIN_INPUT_BUFFER_UNITS = 1n
